// Smart filter drawer — submit jako `?filter_kolor=czarny,szary` (WC native layered nav format).

function initFilterDrawer() {
  const drawer = document.getElementById('filter-drawer');
  if (!drawer) return;
  const panel = drawer.querySelector('[data-fd-panel]');
  const backdrop = drawer.querySelector('[data-fd-backdrop]');
  const form = drawer.querySelector('[data-fd-form]');

  function open() {
    drawer.classList.remove('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      backdrop.style.opacity = '1';
      panel.classList.remove('-translate-x-full');
    });
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('kb-fd-open');
  }
  function shut() {
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.style.opacity = '0';
    panel.classList.add('-translate-x-full');
    setTimeout(() => drawer.classList.add('pointer-events-none'), 280);
    document.documentElement.style.overflow = '';
    document.body.classList.remove('kb-fd-open');
  }

  document.querySelectorAll('[data-filters-open]').forEach((b) => b.addEventListener('click', open));
  drawer.querySelectorAll('[data-fd-close]').forEach((b) => b.addEventListener('click', shut));
  backdrop.addEventListener('click', shut);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') shut();
  });

  const clearBtn = drawer.querySelector('[data-fd-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      drawer.querySelectorAll('input[type="number"]').forEach((i) => { i.value = ''; });
      drawer.querySelectorAll('input[type="checkbox"]').forEach((c) => { c.checked = false; });
      // Pill style reset
      drawer.querySelectorAll('label.border-black.bg-black').forEach((l) => {
        l.classList.remove('border-black', 'bg-black', 'text-white');
        l.classList.add('hairline');
      });
    });
  }

  // Pill toggle visual sync
  drawer.querySelectorAll('label > input[type="checkbox"]').forEach((inp) => {
    inp.addEventListener('change', () => {
      const lbl = inp.closest('label');
      if (!lbl) return;
      if (lbl.classList.contains('h-11') && lbl.querySelector('span')) {
        // Pill style
        if (inp.checked) {
          lbl.classList.add('border-black', 'bg-black', 'text-white');
          lbl.classList.remove('hairline');
        } else {
          lbl.classList.remove('border-black', 'bg-black', 'text-white');
          lbl.classList.add('hairline');
        }
      }
    });
  });

  // Submit: collapse `filter_kolor[]=czarny&filter_kolor[]=szary` → `?filter_kolor=czarny,szary`
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams();
      const groups = {};
      form.querySelectorAll('input[name]').forEach((inp) => {
        if (inp.type === 'checkbox' && !inp.checked) return;
        if (!inp.value) return;
        const name = inp.name.replace(/\[\]$/, '');
        if (inp.type === 'checkbox') {
          if (!groups[name]) groups[name] = [];
          groups[name].push(inp.value);
        } else {
          // number / text
          params.set(name, inp.value);
        }
      });
      Object.entries(groups).forEach(([name, values]) => {
        params.set(name, values.join(','));
      });
      const base = window.location.pathname;
      const qs = params.toString();
      window.location.href = base + (qs ? '?' + qs : '');
    });
  }

  // Caret rotation tied to <details> open state
  drawer.querySelectorAll('.fd-section').forEach((sec) => {
    const caret = sec.querySelector('.fd-caret');
    const sync = () => { if (caret) caret.style.transform = sec.open ? 'rotate(180deg)' : ''; };
    sec.addEventListener('toggle', sync);
    sync();
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initFilterDrawer();
  else document.addEventListener('DOMContentLoaded', initFilterDrawer);
}
